var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-page-wrapper"},[_c('HeroSection'),_c('AboutSection',{attrs:{"image-data":_vm.imageData},on:{"show-modal":_vm.showModal}}),_c('BusinessMatrix'),_c('CoreValues'),(_vm.isModalVisible)?_c('ImageModal',{attrs:{"image-src":_vm.imageData.highQuality},on:{"close":_vm.closeModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }